/**
 * Basic Life skeleton
 *
 * IMPORTANT: Benefits are in GRID FORMAT (flat fields), not API format (nested objects).
 * This allows proper merging with data transformed from API via transformFromApi.
 */

import {
  BaseBenefitPlanPolicyPeriod,
  RfpCoverage,
  CoverageTypeEnum,
  BenefitPlanTypeEnum,
  PlanOptionNameEnum,
  FundingTypeEnum,
  RfpBenefitPlan,
} from "../../types/rfp.api.types";

export const getBasicLifeSkeleton = (): Partial<RfpCoverage> => ({
  type: CoverageTypeEnum.BASIC_LIFE_ADND,
  status: "quoted",
  notes: "",
  benefitPlans: [
    {
      identifier: "basicLifeAdnd-plan-1",
      name: "Basic Life & AD&D Plan",
      numberOfLives: 0,
      type: BenefitPlanTypeEnum.NOT_APPLICABLE,
      policyPeriod: BaseBenefitPlanPolicyPeriod.newBusiness,
      fundingType: FundingTypeEnum.NOT_APPLICABLE,
      rateGuarantee: undefined,
      rateCap: "",
      optionName: PlanOptionNameEnum.NOT_APPLICABLE,
      benefitClassAvailability: [],
      rateSchedule: [],
      benefits: {
        objectType: "basicLifeAdnd",

        // Benefit Amount (Grid Format - Flat Fields)
        benefitAmountType: undefined,
        benefitAmountDollarAmount: undefined,
        benefitAmountSalaryMultiplier: undefined,

        // Benefit Maximum (Grid Format - Flat Fields)
        benefitMaximumType: undefined,
        benefitMaximumDollarAmount: undefined,
        benefitMaximumSalaryMultiplier: undefined,

        // Guarantee Issue (Grid Format - Flat Fields)
        guaranteeIssueType: undefined,
        guaranteeIssueSalaryMultiplier: undefined,
        guaranteeIssueDollarAmount: undefined,
        guaranteeIssueAdditionalAmount: undefined,

        // Definition of Earnings (Grid Format - Flat Fields)
        definitionOfEarningsType: undefined,
        definitionOfEarningsAverageMonths: undefined,

        // Spouse Benefit (Grid Format - Flat Fields)
        spouseBenefitType: undefined,
        spouseBenefitAmount: undefined,

        // Child Benefit (Grid Format - Flat Fields)
        childBenefitType: undefined,
        childBenefitAmount: undefined,

        // Age Reduction Schedule (Grid Format - Flat Fields)
        ageReductionScheduleType: undefined,
        ageReductionScheduleSchedules: [],

        // Simple fields
        portability: undefined,
        conversion: undefined,
        acceleratedDeathBenefit: undefined,
        waiverOfPremium: undefined,
        employerContribution: undefined,

        // Extended (non-v5) fields — CD-1662/CD-2070
        eligibilityHours: undefined,
        waiverOfPremiumEligibility: undefined,
        waiverOfPremiumWaitingPeriod: undefined,
        waiverOfPremiumDuration: undefined,
        airBag: undefined,
        commonCarrier: undefined,
        repatriation: undefined,
        seatBelt: undefined,
        eapFaceToFaceVisitsLimitType: undefined,
        eapVisitCount: undefined,
        travelAid: undefined,
      },
    } as RfpBenefitPlan,
  ],
});
